import {
  isEmptySale,
  hasLineItems,
  isMarkedAsUnfulfilled,
  isReturn,
  isBlindReturn,
  isLegacyServiceSale,
} from '../../../functions/sale'
import { hasServiceOrder } from '../../../functions/service'
import { useAppSelector } from '../../../state/hooks'
import {
  selectCurrentSale,
  selectSaleHasLineItemFulfilment,
} from '../../../state/slices/currentSale/currentSaleSlice'
import { getFeatureFromCache } from '../../../util/feature-cache'
import { FEATURE_FAILFAST_BULK_SOLD_BY } from '../../../constants/wr-features'

/**
 * hook to determine display and enable/ disable state of more action menu items
 */
export const useMoreActionsPopover = (shouldDisableActions: boolean) => {
  const sale = useAppSelector(selectCurrentSale)
  const hasLineItemFulfilment = useAppSelector(selectSaleHasLineItemFulfilment)

  const saleState = {
    isEmptySale: isEmptySale(sale),
    hasLineItems: hasLineItems(sale),
    hasLineItemFulfilment,
    isMarkedAsUnfulfilled: isMarkedAsUnfulfilled(sale.status),
    isReturn: isReturn(sale) || isBlindReturn(sale),
    hasServiceOrder:
      hasServiceOrder(sale.serviceFields, sale.customFields) ||
      isLegacyServiceSale(sale.status),
  }
  const shouldDisableQuote =
    shouldDisableActions ||
    !saleState.hasLineItems ||
    saleState.isMarkedAsUnfulfilled ||
    saleState.isReturn ||
    saleState.hasServiceOrder

  const shouldDisableService =
    shouldDisableActions ||
    saleState.isReturn ||
    saleState.hasServiceOrder ||
    saleState.hasLineItemFulfilment ||
    !saleState.hasLineItems ||
    saleState.isMarkedAsUnfulfilled

  const shouldDisableDiscardSale = shouldDisableActions

  const isServiceOrderEnabled = getFeatureFromCache('enable_service_orders')

  const shouldDisableMarkAsUnfulfilled =
    shouldDisableActions ||
    saleState.hasServiceOrder ||
    saleState.isReturn ||
    !saleState.hasLineItems

  const isBulkSoldByEnabled =
    getFeatureFromCache(FEATURE_FAILFAST_BULK_SOLD_BY) &&
    getFeatureFromCache('sales_person_attribution')

  return {
    shouldDisableQuote,
    shouldDisableService,
    shouldDisableMarkAsUnfulfilled,
    shouldDisableDiscardSale,
    isServiceOrderEnabled,
    isBulkSoldByEnabled,
  }
}
